import React, { useState, useEffect } from "react";
import { Modal, Form, InputNumber, Input, message } from "antd";
import { changeEcheanceAmount } from "../api/subscriptions/subscriptionsRequest";

const { TextArea } = Input;

const ChangeEcheanceAmountModal = ({ 
  visible, 
  onCancel, 
  onSuccess, 
  echeance 
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && echeance) {
      form.setFieldsValue({
        new_amount: echeance.amount,
        reason: ""
      });
    }
  }, [visible, echeance, form]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const response = await changeEcheanceAmount(echeance.id, values);
      
      if (response.success) {
        message.success(response.message || "Montant de l'échéance mis à jour avec succès");
        form.resetFields();
        onSuccess();
      } else if (response.message === 'No change detected') {
        message.info("Aucun changement détecté");
        onCancel();
      } else {
        message.error(response.error || "Erreur lors de la mise à jour");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || "Erreur lors de la mise à jour du montant de l'échéance";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  return (
    <Modal
      title="Modifier le montant de l'échéance"
      open={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      okText="Enregistrer"
      cancelText="Annuler"
      width={600}
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        initialValues={{
          new_amount: 0,
          reason: ""
        }}
      >
        <Form.Item
          label="Nouveau montant"
          name="new_amount"
          rules={[
            { required: true, message: "Le montant est requis" },
            { type: 'number', min: 0, message: "Le montant doit être positif ou nul" }
          ]}
        >
          <InputNumber
            style={{ width: '100%' }}
            placeholder="Entrer le nouveau montant"
            min={0}
            step={0.01}
            precision={2}
          />
        </Form.Item>

        <Form.Item
          label="Raison de la modification"
          name="reason"
          rules={[
            { max: 1000, message: "La raison ne peut pas dépasser 1000 caractères" }
          ]}
        >
          <TextArea 
            rows={4} 
            placeholder="Expliquer la raison de cette modification du montant..."
          />
        </Form.Item>
      </Form>

      {echeance && (
        <div style={{ marginTop: 16, padding: 12, backgroundColor: "#f5f5f5", borderRadius: 4 }}>
          <strong>Informations de l'échéance :</strong>
          <div>Période: {formatDate(echeance.start_date)} - {formatDate(echeance.end_date)}</div>
          <div>Montant actuel: {echeance.amount} DH</div>
          <div>Statut: {echeance.status === 'pending' ? 'En attente' : echeance.status === 'paid' ? 'Payé' : echeance.status}</div>
        </div>
      )}
    </Modal>
  );
};

export default ChangeEcheanceAmountModal;